import { DeliveryProvider, OFFER_KIND, PaymentMethod } from '../../../../../services/exports/Constants';

export default {
  customer_info: {
    dummy_order: 'Testbestelling',
    ordered_at: 'Besteld om:',
  },
  delivery_info: {
    info: 'Bezorginformatie:',
  },
  order_note: {
    label: 'Opmerking bij bestelling:',
  },
  schedule_info: {
    pickup: 'Afhalen',
    delivery: 'Bezorging',
    on_site: 'Bestelling aan tafel',
    wish_time: 'Gewenste tijd:',
    confirmed_time: 'Bevestigde tijd:',
    driver_arrival_time: 'Ophaaltijd chauffeur:',
    external_delivery: 'De bestelling wordt bezorgd door een externe chauffeur van {{carrier}}',
  },
  products: {
    item: 'Artikel:',
  },
  discount_breakdown: {
    label: 'Korting',
    [OFFER_KIND.PERCENTAGE_OFF_BY_MIN_SPEND_VALUE]: 'Percentage korting op totaal toegepast',
    [OFFER_KIND.PERCENTAGE_OFF_BY_PRODUCTS]: 'Percentage korting op producten toegepast',
    [OFFER_KIND.AMOUNT_OFF_BY_PRODUCTS]: 'Bedrag korting op producten toegepast',
    [OFFER_KIND.AMOUNT_OFF_BY_MIN_SPEND_VALUE]: 'Bedrag korting op totaal toegepast',
    [OFFER_KIND.BOGO]: 'Bogo toegepast',
    [OFFER_KIND.BOGO_HALF_PRICE]: 'Bogo halve prijs toegepast',
    [OFFER_KIND.FREE_ITEM_BY_PRODUCTS]: 'Gratis artikel op producten toegepast',
    [OFFER_KIND.FREE_ITEM_BY_MIN_SPEND_VALUE]: 'Gratis artikel op totaal toegepast',
    GiftCard: 'Cadeaukaart toegepast',
    Reward: 'Spaarpunten toegepast',
    CashbackAccount: 'Spaarpunten toegepast',
    PromoCodeComponent: 'Promotie toegepast',
    Offer: 'Aanbieding toegepast',
  },
  payment_breakdown: {
    price: 'Prijs:',
    subtotal: 'Subtotaal',
    delivery_fee: 'Bezorgkosten',
    tips: 'Fooi',
    processing_fee: 'Online servicekosten',
    payment_method_upcharge_fee: {
      [PaymentMethod.Paypal]: 'PayPal-kosten',
    },
    tax: 'Belastingen',
    total: 'Totaal',
    paid_amount: 'Betaald bedrag',
    order_not_paid: 'Bestelling nog niet betaald',
    order_paid_online: 'Al online betaald',
    cash: 'Betaling ter plaatse',
    this_is_not_an_invoice: 'Dit is geen factuur',
  },
  delivery_qr_code: {
    scan: 'Scan & bezorg met Google Maps',
  },
  delivery_providers: {
    [DeliveryProvider.UberDrive]: 'Uber',
    [DeliveryProvider.FirstDelivery]: 'Uber',
    [DeliveryProvider.WoltDrive]: 'Wolt',
  },
};
